import React from "react";
import { Button, Form } from "react-bootstrap";
import { FaSyncAlt } from "react-icons/fa";

const BreakfastFilters = ({
  filters,
  properties,
  loading,
  onFilterChange,
  onRefresh,
}) => {
  return (
    <div className="card admin-surface-card admin-filter-card mb-4">
      <div className="card-body admin-surface-body">
        <div className="row g-3 align-items-end">
          <Form.Group className="col-md-4">
            <Form.Label>Property</Form.Label>
            <Form.Select
              value={filters.propertyId}
              onChange={(event) =>
                onFilterChange("propertyId", event.target.value)
              }
            >
              <option value="">All properties</option>
              {properties.map((property) => (
                <option key={property.propertyId} value={property.propertyId}>
                  {property.propertyName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-md-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={filters.status}
              onChange={(event) => onFilterChange("status", event.target.value)}
            >
              <option value="">All statuses</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="col-md-4">
            <Form.Label>Search</Form.Label>
            <Form.Control
              value={filters.search}
              placeholder="Property or room type"
              onChange={(event) => onFilterChange("search", event.target.value)}
            />
          </Form.Group>

          <div className="col-md-1">
            <Button
              variant="outline-secondary"
              className="w-100"
              onClick={onRefresh}
              disabled={loading}
              title="Refresh"
            >
              <FaSyncAlt className={loading ? "fa-spin" : ""} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakfastFilters;
